import getNative from './_getNative';
import root from './_root';

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

export default WeakMap;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_WeakMap.js
// module id = null
// module chunks = 